module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-dusty-rose-1-f590c5c6746742333347580d06f519f6.webp";